import type { Meta, StoryObj } from "@storybook/react";

import {
  OnboardingStepName,
  OrderedOnboardingSteps,
} from "@/constants/Onboarding";
import type {
  OnboardingCollapsedStepCardProps,
  OnboardingCollapsedStepCardState,
} from "@/ui/components/onboarding/v2/cards/OnboardingCollapsedStepCard";
import { OnboardingCollapsedStepCard } from "@/ui/components/onboarding/v2/cards/OnboardingCollapsedStepCard";
import { VStack } from "@/ui/layout";

const states: OnboardingCollapsedStepCardState[] = ["complete", "pending"];

const StoryMeta: Meta<OnboardingCollapsedStepCardProps> = {
  title: "Components/Onboarding/Cards/Onboarding Collapsed Step Card",
  component: OnboardingCollapsedStepCard,
  args: {
    state: "pending",
    stepName: OnboardingStepName.Profile,
    testID: "story",
  },
  argTypes: {
    state: {
      control: "select",
      options: states,
    },
    stepName: {
      control: "select",
      options: OrderedOnboardingSteps,
    },
  },
};

type Story = StoryObj<OnboardingCollapsedStepCardProps>;

const Pending: Story = {
  args: { state: "pending" },
};

const Complete: Story = {
  args: { state: "complete" },
};

const AllStepsPending: Story = {
  args: { state: "pending" },
  render: (args) => (
    <VStack gap={8} width="100%">
      {OrderedOnboardingSteps.map((stepName) => (
        <OnboardingCollapsedStepCard
          {...args}
          key={stepName}
          stepName={stepName}
          testID={stepName}
        />
      ))}
    </VStack>
  ),
};

const AllStepsComplete: Story = {
  args: { state: "complete" },
  render: (args) => (
    <VStack gap={8} width="100%">
      {OrderedOnboardingSteps.map((stepName) => (
        <OnboardingCollapsedStepCard
          {...args}
          key={stepName}
          stepName={stepName}
          testID={stepName}
        />
      ))}
    </VStack>
  ),
};

export { AllStepsComplete, AllStepsPending, Complete, Pending };
export default StoryMeta;
